import {
  getTableOfCategorizationsDart,
  getCategorizationDart,
  sendForImprovement,
  sendToComission,
  getTableOfVotingHistoryDart,
  getCommentsDart,
  leaveCommentDart,
  existingCategorizationСomments,
  getTableOfReportsDart,
  addCommentReportDart,
  existingReportСomments,
  sendReportForImprovementDart,
  approveTourOperatorsReport,
  getDartNotifications,
  getDartNotification,
  createNotification,
  createFullCategorizationRequestDart,
  addCategorizationRequestDraft,
  deleteCategorizationRequest,
  getCategorizationDraft,
  editCategorizationRequestDraft,
} from '@/api/services/dart.js';
import router from '@/router';
import VueI18n from '@/i18n';

export default {
  state: {
    tableOfCategorizationsDart: [],
    categorizationDart: [],
    tableOfVotingHistoryDart: [],
    commentsDart: [],
    tableOfTourOperatorsReportsDart: null,
    existingCategorizationСomments: false,
    existingReportСomments: false,
    tableOfDartNotifications: [],
    dartNotification: {},
    categorizationFormState: [],
  },

  getters: {
    getTableOfCategorizationsDart: (state) => state.tableOfCategorizationsDart,
    getTableOfVotingHistoryDart: (state) => state.tableOfVotingHistoryDart,
    getCategorizationDart: (state) => state.categorizationDart,
    getCommentsDart: (state) => state.commentsDart,
    tableOfReportsDart: (state) => state.tableOfTourOperatorsReportsDart,
    isExistgCategorizationСomments: (state) =>
      state.existingCategorizationСomments,
    isExistingReportСomments: (state) => state.existingReportСomments,
    getTableOfDartNotifications: (state) => state.tableOfDartNotifications,
    getDartNotification: (state) => state.dartNotification,
    getCategorizationHotelDart: (state) => state.categorizationFormState,
  },

  mutations: {
    SET_CATEGORIZATION_TABLE_DART(state, data) {
      state.tableOfCategorizationsDart = data;
    },
    SET_TABLE_OF_VOTING_DART(state, data) {
      state.tableOfVotingHistoryDart = data;
    },
    SET_CATEGORIZATION_DART(state, data) {
      state.categorizationDart = data;
    },
    SET_COMMENTS_DART(state, data) {
      state.commentsDart = data;
    },
    SET_EXISTING_CATEGORIZATION_СOMMENTS(state, value) {
      state.existingCategorizationСomments = value;
    },
    SET_EXISTING_REPORT_СOMMENTS(state, value) {
      state.existingReportСomments = value;
    },
    SET_TABLE_OF_REPORTS_DART(state, data) {
      state.tableOfTourOperatorsReportsDart = data;
    },
    SET_TABLE_OF_DART_NOTIFICATIONS(state, data) {
      state.tableOfDartNotifications = data;
    },
    SET_DART_NOTIFICATIONS(state, data) {
      state.dartNotification = data;
    },
    SET_CATEGORIZATION_FORM_STATE_DART(state, data) {
      state.categorizationFormState = data;
    },
  },

  actions: {
    async getTableOfDartNotifications({ commit, getters }) {
      try {
        let res;
        res = await getDartNotifications(getters.getTableSortData);
        if (res.status === 200) {
          commit('SET_TABLE_OF_DART_NOTIFICATIONS', res.data.data);
          commit('SET_CURRENT_PAGE', res.data.data.table.current_page);
          commit('SET_LAST_PAGE', res.data.data.table.last_page);
        }
      } catch (e) {
        console.log(
          '>>> error getTableOfDartNotifications',
          e.response.data.error
        );
      }
    },
    async getDartNotification({ commit }, uuid) {
      try {
        let res;
        res = await getDartNotification(uuid);
        if (res.status === 200) {
          commit('SET_DART_NOTIFICATIONS', res.data.data.notification);
        }
      } catch (e) {
        console.log(
          '>>> error getDartNotification',
          e.response.data.error
        );
      }
    },
    async createDartNotification({ commit }, payload) {
      try {
        await createNotification(payload);
        commit('GET_IS_ERROR', false);
        commit('SHOW_NOTIFICATION', true);
        commit('GET_RESPONSE_MESSAGE', VueI18n.t('notification_form.success_message'));

        router.push({
          name: 'dart_notifications',
        })
      } catch (error) {
        commit('GET_IS_ERROR', true);
        commit('SHOW_NOTIFICATION', true);
        commit('GET_RESPONSE_MESSAGE', VueI18n.t('notification_form.error_message'));
      }
    },
    async getTableOfCategorizationsDart({ commit, getters }) {
      try {
        let res;
        res = await getTableOfCategorizationsDart(getters.getTableSortData);
        if (res.status === 200) {
          commit('SET_CATEGORIZATION_TABLE_DART', res.data.data);
          commit('SET_CURRENT_PAGE', res.data.data.table.current_page);
          commit('SET_LAST_PAGE', res.data.data.table.last_page);
        }
      } catch (e) {
        console.log(
          '>>> error getTableOfCategorizations',
          e.response.data.error
        );
      }
    },
    async getTableOfVotingHistoryDart({ commit, getters }) {
      try {
        let res;
        res = await getTableOfVotingHistoryDart(getters.getTableSortData);
        if (res.status === 200) {
          commit('SET_TABLE_OF_VOTING_DART', res.data.data);
          commit('SET_CURRENT_PAGE', res.data.data.table.current_page);
          commit('SET_LAST_PAGE', res.data.data.table.last_page);
        }
      } catch (e) {
        console.log(
          '>>> error getTableOfVotingHistoryDart',
          e.response.data.error
        );
      }
    },

    async getCategorizationDart({ commit, dispatch }, uuid) {
      let res;
      try {
        res = await getCategorizationDart(uuid);
        if (res.status === 200) {
          commit(
            'SET_CATEGORIZATION_DART',
            res.data.data.categorization_application
          );
          dispatch('checkExistingCategorizationСomments', uuid);
        }
      } catch (e) {
        console.log('>>> getCategorizationDart error', e);
      }
    },

    async getCategorizationHotelDart({ commit }, data) {
      let res;
      try {
        res = await getCategorizationDraft(data);
        commit(
          'SET_CATEGORIZATION_FORM_STATE_DART',
          res.data.data.categorization_application
        );
      } catch (e) {
        console.log('>>> getCategorizationHotelDart error', e);
      }
    },

    async editCategorizationRequestDart({ commit }, data) {
      let res;
      try {
        res = await editCategorizationRequestDraft(data);
        if (res.status === 200) {
          router.push({ name: 'dart_hotel-categorizations' });
          commit('GET_IS_ERROR', false);
          commit('SHOW_NOTIFICATION', true);
          commit(
            'GET_RESPONSE_MESSAGE',
            VueI18n.t('notification.data_is_saved')
          );
        }
      } catch (e) {
        commit('SHOW_NOTIFICATION', true);
        commit('GET_RESPONSE_MESSAGE', e.response.data.message);
        commit('GET_IS_ERROR', true);
      }
    },

    async getCommentsDart({ commit }, uuid) {
      let res;
      try {
        res = await getCommentsDart(uuid);
        commit('SET_COMMENTS_DART', res.data.data.criterias);
      } catch (e) {
        console.log('>>> getCommentsDart error', e);
      }
    },

    async sendForImprovement({ commit }, uuid) {
      let res;
      try {
        res = await sendForImprovement(uuid);
        router.push({ name: 'dart_hotel-categorizations' });
        commit('SHOW_NOTIFICATION', true);
        commit('GET_RESPONSE_MESSAGE', VueI18n.t('notification.sent'));
      } catch (e) {
        commit('SHOW_NOTIFICATION', true);
        commit('GET_RESPONSE_MESSAGE', e.response.data.message);
        commit('GET_IS_ERROR', true);
      }
    },

    async sendToComission({ commit }, uuid) {
      let res;
      try {
        res = await sendToComission(uuid);
        router.push({ name: 'dart_hotel-categorizations' });
        commit('SHOW_NOTIFICATION', true);
        commit('GET_RESPONSE_MESSAGE', VueI18n.t('notification.sent'));
      } catch (e) {
        commit('SHOW_NOTIFICATION', true);
        commit('GET_RESPONSE_MESSAGE', e.response.data.message);
        commit('GET_IS_ERROR', true);
      }
    },

    async addCommentHotelDart({ commit, dispatch }, payload) {
      let res;
      try {
        res = await leaveCommentDart(
          payload.criterion_uuid,
          payload.categorization_application_uuid,
          payload.comment
        );

        if (res.status === 200) {
          commit('SHOW_NOTIFICATION', true);
          commit('GET_RESPONSE_MESSAGE', VueI18n.t('notification.sent'));
          dispatch(
            'checkExistingCategorizationСomments',
            payload.categorization_application_uuid
          );

          return res.data.data.result;
        }
      } catch (e) {
        commit('SHOW_NOTIFICATION', true);
        commit('GET_RESPONSE_MESSAGE', e.response.data.message);
        commit('GET_IS_ERROR', true);
      }

    },

    async addCommentReportDart({ commit, dispatch }, payload) {
      let res;
      try {
        res = await addCommentReportDart(
          payload.criterion_uuid,
          payload.report_uuid,
          payload.comment
        );

        if (res.status === 200) {
          commit('SHOW_NOTIFICATION', true);
          commit('GET_RESPONSE_MESSAGE', VueI18n.t('notification.sent'));
          dispatch('checkExistingReportСomments', payload.report_uuid);
        }
      } catch (e) {
        console.log('>>> addCommentToTourOperatorFromDart error', e);
        commit('SHOW_NOTIFICATION', true);
        commit('GET_RESPONSE_MESSAGE', e.response.data.message);
        commit('GET_IS_ERROR', true);
      }
    },

    async checkExistingCategorizationСomments({ commit }, uuid) {
      let res;
      try {
        res = await existingCategorizationСomments({ uuid });
        if (res.status === 200) {
          commit(
            'SET_EXISTING_CATEGORIZATION_СOMMENTS',
            res.data.data.exists_comment
          );
        }
      } catch (e) {
        console.log('>>>> checkExistingCategorizationСomments error', e);
      }
    },

    async checkExistingReportСomments({ commit }, uuid) {
      let res;
      try {
        res = await existingReportСomments({ uuid });
        if (res.status === 200) {
          commit('SET_EXISTING_REPORT_СOMMENTS', res.data.data.exists_comment);
        }
      } catch (e) {
        console.log('>>>> checkExistingReportСomments error', e);
      }
    },

    async addCategorizationRequestDraftDart({ commit }, data) {
      let res;
      try {
        res = await addCategorizationRequestDraft(data);
        commit('SHOW_NOTIFICATION', true);
        commit('GET_RESPONSE_MESSAGE', VueI18n.t('notification.data_is_saved'));
        router.push({ name: 'dart_hotel-categorizations' });
      } catch (e) {
        commit('SHOW_NOTIFICATION', true);

        for(let k in e.response.data.errors) {
          commit('GET_RESPONSE_MESSAGE', e.response.data.errors[k][0]);
        }
        commit('GET_IS_ERROR', true);
      }
    },

    async deleteCategorizationDraftDart({ commit, dispatch }, uuid) {
      let res;
      let data = { categorization_application_uuid: uuid };
      try {
        res = await deleteCategorizationRequest(data);
        if (res.status === 200) {
          dispatch('getTableOfCategorizationsDart');
          commit('SHOW_NOTIFICATION', true);
          commit(
            'GET_RESPONSE_MESSAGE',
            VueI18n.t('notification.draft_deleted')
          );
        }
      } catch (e) {
        console.log('>>>> deleteCategorizationDraftDart error', e);
        commit('SHOW_NOTIFICATION', true);
        commit('GET_RESPONSE_MESSAGE', e.response);
        commit('GET_IS_ERROR', true);
      }
    },

    async createFullCategorizationRequestDart({ commit }, data) {
      let res;
      try {
        res = await createFullCategorizationRequestDart(data);
        
        if (res.status === 200) {
          router.push({ name: 'dart_hotel-categorizations' });
          // commit('SET_CATEGORISATION_DRAFT_SAVED_CA', true);
          commit('GET_IS_ERROR', false);
          commit('SHOW_NOTIFICATION', true);
          commit(
            'GET_RESPONSE_MESSAGE',
            VueI18n.t('notification.data_is_saved')
          );
          commit(
            'SET_DATA_TO_SIGN',
            res.data.data.categorization_application.uuid
          );
          // commit('modal/SET_MODAL', {
          //   state: true,
          //   name: 'add-key',
          //   size: 'l',
          // });
        }
      } catch (e) {
        commit('SHOW_NOTIFICATION', true);
        // commit('GET_RESPONSE_MESSAGE', e.response.data?.errors.application);
        for(let k in e.response.data.errors) {
          commit('GET_RESPONSE_MESSAGE', e.response.data.errors[k][0]);
        }
        commit('GET_IS_ERROR', true);
        // router.push({ name: 'certificate_agency_hotel_categorizations-list' });
        console.log(
          '>>> createFullCategorizationRequestCA error',
          e.response.data?.errors.application
        );
      }
    },

    async getTableOfReportsDart({ commit, getters }) {
      let res;
      try {
        res = await getTableOfReportsDart(getters.getTableSortData);
        if (res.status === 200) {
          commit('SET_TABLE_OF_REPORTS_DART', res.data.data);
          commit('SET_CURRENT_PAGE', res.data.data.table.current_page);
          commit('SET_LAST_PAGE', res.data.data.table.last_page);
        }
      } catch (e) {
        console.log('>>> getTableOfReportsDart error', e);
      }
    },

    async sendReportForImprovementDart({ commit }, uuid) {
      let res;
      try {
        res = await sendReportForImprovementDart({ uuid });
        if (res.status === 200) {
          router.push({ name: 'dart_tour-operator-reports' });
          commit('SHOW_NOTIFICATION', true);
          commit('GET_RESPONSE_MESSAGE', VueI18n.t('notification.sent'));
        }
      } catch (e) {
        console.log('>>> sendForImprovementHandler error', e);
        commit('SHOW_NOTIFICATION', true);
        commit('GET_RESPONSE_MESSAGE', e.response.data.message);
        commit('GET_IS_ERROR', true);
      }
    },

    async approveTourOperatorsReport({ commit }, uuid) {
      let res;
      try {
        res = await approveTourOperatorsReport({ uuid });
        if (res.status === 200) {
          router.push({ name: 'dart_tour-operator-reports' });
          commit('SHOW_NOTIFICATION', true);
          commit('GET_RESPONSE_MESSAGE', VueI18n.t('notification.approved'));
        }
      } catch (e) {
        console.log('>>>> approveTourOperatorsReport error', r);
        commit('SHOW_NOTIFICATION', true);
        commit('GET_RESPONSE_MESSAGE', e.response.data.message);
        commit('GET_IS_ERROR', true);
      }
    },
  },


};
